export function numericTransformer(
	value: string,
	callback: (v: string | null) => void,
	{fractionDigits = 0, negativeAllowed = false} = {},
) {
	if (!value) return callback(null);

	const negativeSign = negativeAllowed ? '-' : '';
	const hasInvalidChars = new RegExp(`[^0-9.,${negativeSign}]`, 'g').test(value);
	const hasMultipleDelimiters = /[.,].*[.,]/g.test(value);

	if (hasInvalidChars || hasMultipleDelimiters) return;

	const endsWithDelimiter = /[.,]$/.test(value);

	if (endsWithDelimiter && fractionDigits === 0) return;

	const [, fraction] = value.split(/[.,]/);

	if (fraction?.length > fractionDigits) return;

	callback(value);
}
